// App
export const SHOW_MESSAGE = 'show_message'
export const HIDE_MESSAGE = 'hide_message'
export const ON_SHOW_LOADER = 'on_show_loader'
export const ON_HIDE_LOADER = 'on_hide_loader'

// Forms
export const SHOW_FORM_MESSAGE = 'show_form_message'
export const HIDE_FORM_MESSAGE = 'hide_form_message'
export const GET_FORM = 'get_form'
export const GET_FORM_SUCCESS = 'get_form_success'
export const GET_CLIENT_INFO = 'get_client_info'
export const GET_CLIENT_INFO_SUCCESS = 'get_client_info_success'

// Responses
export const SHOW_RESPONSE_MESSAGE = 'show_response_message'
export const HIDE_RESPONSE_MESSAGE = 'hide_response_message'
export const GET_RESPONSE = 'get_response'
export const GET_RESPONSE_SUCCESS = 'get_response_success'
export const GET_RESPONSE_MODES = 'get_response_modes'
export const GET_RESPONSE_MODES_SUCCESS = 'get_response_modes_success'
export const SAVE_RESPONSE = 'save_response'
export const SAVE_RESPONSE_SUCCESS = 'save_response_success'
export const SAVE_RESPONSE_MOBILE = 'save_response_mobile'
export const SAVE_RESPONSE_MOBILE_SUCCESS = 'save_response_mobile_success'
export const SAVE_RESPONSE_MOBILE_TOKEN = 'save_response_mobile_token'
export const SAVE_RESPONSE_MOBILE_TOKEN_SUCCESS = 'save_response_mobile_token_success'
export const SAVE_RESPONSE_EMAIL = 'save_response_email'
export const SAVE_RESPONSE_EMAIL_SUCCESS = 'save_response_email_success'
export const SAVE_RESPONSE_EMAIL_TOKEN = 'save_response_email_token'
export const SAVE_RESPONSE_EMAIL_TOKEN_SUCCESS = 'save_response_email_token_success'
export const RETURN_APPLICATION = 'return_application'
export const CANCEL_RETURN = 'cancel_return'
export const SAVE_RESPONSE_FILE = 'save_response_file'
export const SAVE_RESPONSE_FILE_SUCCESS = 'save_response_file_success'
export const SAVE_RESPONSE_SIGNED_FILE = 'save_response_signed_file'
export const SAVE_RESPONSE_SIGNED_FILE_SUCCESS = 'save_response_signed_file_success'

// PDF SERVER
export const DOWNLOAD_RESPONSE = 'download_response'
export const DOWNLOAD_RESPONSE_SUCCESS = 'download_response_success'
